export const TUI_LIGHT = 'tui-light';
